import { getLocalRecentHistoryList } from 'dibs-recent-history/exports/getLocalRecentHistoryList.ts';

const HOMEPAGE_RECENTLY_VIEWED_COUNT = 4;

export function getRecentlyViewedItemIds(): string[] {
    const list = getLocalRecentHistoryList([], HOMEPAGE_RECENTLY_VIEWED_COUNT) || [];
    return list
        .slice()
        .reverse()
        .map(entry => entry.itemId)
        .filter((itemId): itemId is string => !!itemId);
}
